var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"scrollTop",on:{"click":_vm.scrollTop}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-chevron-up"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }